import React, { useState } from "react";
import classNames from "classnames";
import { Paragraph } from "@campgladiator/cgui-core.atoms.typography";
import { Tooltip } from "@campgladiator/cgui-core.atoms.tooltip";
import styles from "./accessory-item.module.scss";

export type AccessoryItemProps = {
  label: string;
  link?: string;
  newTab?: boolean;
  tooltipText?: string;
};

const AccessoryItem = ({
  label,
  link,
  newTab,
  tooltipText,
}: AccessoryItemProps) => {
  const [show, setShow] = useState<boolean>(false);

  return (
    <div
      className={styles.accessoryItemContainer}
      onClick={() => setShow(!show)}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {link ? (
        <a
          className={styles.link}
          target={newTab ? "_blank" : "_self"}
          href={link}
        >
          <Paragraph size="xsmall">{label}</Paragraph>
        </a>
      ) : (
        <Paragraph size="xsmall" className={styles.accessoryItem}>
          {label}
        </Paragraph>
      )}

      {tooltipText && (
        <Tooltip
          raised
          arrow="top"
          className={classNames(styles.itemListHeader, styles.toolTipCard, {
            [styles.show]: show,
          })}
        >
          <Paragraph size="xsmall" weight="book" className={styles.toolTipText}>
            {tooltipText}
          </Paragraph>
        </Tooltip>
      )}
    </div>
  );
};

export default AccessoryItem;
